export default __webpack_public_path__ + "static/media/Graphik-Regular-Web.5038847b.woff";